// extracted by mini-css-extract-plugin
module.exports = {"gridWrapper":"styles__gridWrapper--21mhj","msg":"styles__msg--1jKBe"};